import { useRef, useState } from "react";
import { Facebook, Loader2 } from "lucide-react";
import { toPng } from "html-to-image";
import { toast } from "sonner";

export default function FacebookShare({
    path,
    target,
    fileName = "ykpbl-share.png",
    label = "Share",
    testid,
    className = "",
}) {
    const [busy, setBusy] = useState(false);
    const sharing = useRef(false);

    const handleShare = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (sharing.current) return;
        const shareUrl = `${process.env.REACT_APP_BACKEND_URL}/api${path}`;
        const el = target ? document.querySelector(`[data-testid="${target}"]`) : null;
        sharing.current = true;
        setBusy(true);
        try {
            if (!el) throw new Error("capture target not found");
            const dataUrl = await toPng(el, { pixelRatio: 2, cacheBust: true, backgroundColor: "#08080C" });
            const blob = await (await fetch(dataUrl)).blob();
            const file = new File([blob], fileName, { type: "image/png" });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({ files: [file], title: "YKPBL" });
            } else {
                const a = document.createElement("a");
                a.href = dataUrl;
                a.download = fileName;
                a.click();
                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
                    "_blank"
                );
                toast.success("Card image downloaded — attach it to your Facebook post!");
            }
        } catch (err) {
            if (err?.name !== "AbortError") {
                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
                    "_blank"
                );
            }
        } finally {
            sharing.current = false;
            setBusy(false);
        }
    };

    return (
        <button
            type="button"
            data-testid={testid}
            onClick={handleShare}
            disabled={busy}
            className={`inline-flex items-center gap-1.5 text-[10px] font-display font-bold uppercase tracking-widest px-3 py-1.5 rounded-full border border-[#262638] bg-[#08080C]/70 backdrop-blur-sm text-slate-300 hover:border-[#1877F2] hover:text-[#1877F2] disabled:opacity-60 transition-colors duration-200 ${className}`}
        >
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Facebook className="w-3.5 h-3.5" />}
            {label}
        </button>
    );
}
